export const referencias = {
    referencias: [
        {
            nombre: "bajo",
            color:  "#00CC33"
        },
        {
            nombre: "medio",
            color:  "#FFFF00"
        },
        {
            nombre: "alto",
            color:  "#FF9900"
        },
        {
            nombre: "muy alto",
            color:  "#FF0000"
        }
    ]
}